import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import { Helmet } from "react-helmet";
import ListNews from "../components/ListNews";

const Noticias: React.FC = () => {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Começa a distribuição de Vale Gás em São Luís</title>
      </Helmet>

      <Navbar />
      <ListNews />
      <Footer />
    </>
  );
};

export default Noticias;
